import { render, staticRenderFns } from "./ShippingManifestDestinationCorrectionPreviewDialog.vue?vue&type=template&id=1d4319bc&scoped=true&"
import script from "./ShippingManifestDestinationCorrectionPreviewDialog.vue?vue&type=script&lang=ts&"
export * from "./ShippingManifestDestinationCorrectionPreviewDialog.vue?vue&type=script&lang=ts&"
import style0 from "./ShippingManifestDestinationCorrectionPreviewDialog.vue?vue&type=style&index=0&id=1d4319bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d4319bc",
  null
  
)

export default component.exports